import { useMutation } from '@apollo/client/react'

import { GetAccount } from '~publish/contexts/AccountContext'
import { graphql } from '~publish/graphql'
import type { ResultOf, VariablesOf } from '~publish/graphql'

const ACCOUNT_SET_SETTINGS = graphql(`
  mutation accountSetSettings($settings: SettingsInput!) {
    accountSetSettings(settings: $settings) {
      ... on AccountSetSettingsResponse {
        success
        settings {
          aiSettings {
            onboarded
          }
        }
      }
      ... on AccountSetSettingsError {
        userFriendlyMessage
        cause
      }
    }
  }
`)

type AccountSetSettingsData = ResultOf<typeof ACCOUNT_SET_SETTINGS>
type AccountSetSettingsVariables = VariablesOf<typeof ACCOUNT_SET_SETTINGS>
type AccountSetSettingsMutation = ReturnType<
  typeof useMutation<AccountSetSettingsData, AccountSetSettingsVariables>
>

type UseAccountSetSettingsResult = {
  accountSetSettings: AccountSetSettingsMutation[0]
  accountSetSettingsData: AccountSetSettingsMutation[1]['data']
  accountSetSettingsError: AccountSetSettingsMutation[1]['error']
  accountSetSettingsLoading: AccountSetSettingsMutation[1]['loading']
}

export const useAccountSetSettings = (): UseAccountSetSettingsResult => {
  const [
    accountSetSettings,
    {
      data: accountSetSettingsData,
      error: accountSetSettingsError,
      loading: accountSetSettingsLoading,
    },
  ] = useMutation(ACCOUNT_SET_SETTINGS, {
    refetchQueries: [GetAccount],
  })

  return {
    accountSetSettings,
    accountSetSettingsData,
    accountSetSettingsError,
    accountSetSettingsLoading,
  }
}
